export default __webpack_public_path__ + "static/media/yushoudanrenwu.c7aabf89.png";